(function(window, document) {
  "use strict";
  var FIELD_CONFIGS = [ {
    key: "year",
    placeholder: "SELECT YEAR",
    step: "1"
  }, {
    key: "make",
    placeholder: "SELECT MAKE",
    step: "2"
  }, {
    key: "model",
    placeholder: "SELECT MODEL",
    step: "3"
  } ];
  var FIELD_CONFIG_MAP = FIELD_CONFIGS.reduce(function(map, config) {
    map[config.key] = config;
    return map;
  }, {});
  var MAX_API_WAIT_ATTEMPTS = 50;
  var API_WAIT_INTERVAL_MS = 100;
  function getFieldConfig(fieldKey) {
    return FIELD_CONFIG_MAP[fieldKey] || FIELD_CONFIGS[0];
  }
  function getVehicleUtils() {
    return window.AuxitoVehicleUtils || null;
  }
  function getVehicleStorage() {
    var vehicleUtils = getVehicleUtils();
    if (!vehicleUtils || typeof vehicleUtils.getVehicleStorage !== "function") {
      return null;
    }
    return vehicleUtils.getVehicleStorage();
  }
  function waitForVehicleDataApi() {
    return new Promise(function(resolve, reject) {
      var attempts = 0;
      function check() {
        var vehicleUtils = getVehicleUtils();
        attempts += 1;
        if (vehicleUtils && typeof vehicleUtils.waitForVehicleDataApi === "function") {
          try {
            resolve(Promise.resolve(vehicleUtils.waitForVehicleDataApi()));
          } catch (error) {
            reject(error);
          }
          return;
        }
        if (attempts >= MAX_API_WAIT_ATTEMPTS) {
          reject(new Error("AuxitoVehicleUtils not available"));
          return;
        }
        window.setTimeout(check, API_WAIT_INTERVAL_MS);
      }
      check();
    });
  }
  function buildVehicleDisplay(vehicle) {
    var vehicleUtils = getVehicleUtils();
    if (vehicleUtils && typeof vehicleUtils.buildVehicleDisplay === "function") {
      return vehicleUtils.buildVehicleDisplay(vehicle, "");
    }
    return [ vehicle.year, vehicle.make, vehicle.model ].filter(Boolean).join(" ").trim();
  }
  function createOptionButton(label, value) {
    var option = document.createElement("button");
    option.type = "button";
    option.className = "home-vehicle-selector__option";
    option.dataset.value = value;
    option.setAttribute("role", "option");
    option.textContent = label;
    return option;
  }
  function renderPlaceholder(fieldKey) {
    var config = getFieldConfig(fieldKey);
    return '<span class="home-vehicle-selector__trigger-placeholder">' + '<span class="home-vehicle-selector__trigger-step" aria-hidden="true">' + config.step + "</span>" + '<span class="home-vehicle-selector__trigger-label">' + config.placeholder + "</span>" + "</span>";
  }
  function setFieldDisabled(state, fieldKey, disabled) {
    var selectRoot = state.desktopSelects[fieldKey];
    var trigger = selectRoot ? selectRoot.querySelector(".home-vehicle-selector__trigger") : null;
    var nativeSelect = state.nativeSelects[fieldKey];
    if (!selectRoot || !trigger || !nativeSelect) {
      return;
    }
    selectRoot.classList.toggle("is-disabled", !!disabled);
    if (disabled) {
      selectRoot.classList.remove("is-open");
    }
    trigger.setAttribute("aria-disabled", disabled ? "true" : "false");
    trigger.setAttribute("aria-expanded", "false");
    nativeSelect.disabled = !!disabled;
  }
  function syncTriggerValue(state, fieldKey) {
    var selectRoot = state.desktopSelects[fieldKey];
    var trigger = selectRoot ? selectRoot.querySelector(".home-vehicle-selector__trigger") : null;
    var value = state.selections[fieldKey] || "";
    if (!selectRoot || !trigger) {
      return;
    }
    if (value) {
      trigger.classList.remove("is-placeholder");
      trigger.textContent = value;
    } else {
      trigger.classList.add("is-placeholder");
      trigger.innerHTML = renderPlaceholder(fieldKey);
    }
    trigger.setAttribute("aria-label", value || getFieldConfig(fieldKey).placeholder);
    Array.prototype.forEach.call(selectRoot.querySelectorAll(".home-vehicle-selector__option"), function(option) {
      var isSelected = !!value && option.dataset.value === value;
      option.classList.toggle("is-selected", isSelected);
      option.setAttribute("aria-selected", isSelected ? "true" : "false");
    });
  }
  function populateNativeSelect(state, fieldKey, options) {
    var config = getFieldConfig(fieldKey);
    var nativeSelect = state.nativeSelects[fieldKey];
    if (!nativeSelect) {
      return;
    }
    nativeSelect.innerHTML = '<option value="">' + config.placeholder + "</option>";
    options.forEach(function(optionValue) {
      var option = document.createElement("option");
      option.value = optionValue;
      option.textContent = optionValue;
      nativeSelect.appendChild(option);
    });
  }
  function populateDesktopSelect(state, fieldKey, options) {
    var selectRoot = state.desktopSelects[fieldKey];
    var optionsContainer = selectRoot ? selectRoot.querySelector(".home-vehicle-selector__options") : null;
    var config = getFieldConfig(fieldKey);
    if (!selectRoot || !optionsContainer) {
      return;
    }
    optionsContainer.innerHTML = "";
    optionsContainer.appendChild(createOptionButton(config.placeholder, ""));
    options.forEach(function(optionValue) {
      optionsContainer.appendChild(createOptionButton(optionValue, optionValue));
    });
    syncTriggerValue(state, fieldKey);
  }
  function resetField(state, fieldKey, disabled) {
    state.selections[fieldKey] = "";
    state.options[fieldKey] = [];
    populateNativeSelect(state, fieldKey, []);
    populateDesktopSelect(state, fieldKey, []);
    setFieldDisabled(state, fieldKey, disabled);
  }
  function closeAllSelects(state) {
    FIELD_CONFIGS.forEach(function(config) {
      var selectRoot = state.desktopSelects[config.key];
      var trigger = selectRoot ? selectRoot.querySelector(".home-vehicle-selector__trigger") : null;
      if (!selectRoot) {
        return;
      }
      selectRoot.classList.remove("is-open");
      if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  }
  function updateUi(state) {
    var submitButton = state.root.querySelector("[data-home-vehicle-submit]");
    var isComplete = isSelectionComplete(state);
    FIELD_CONFIGS.forEach(function(config) {
      syncTriggerValue(state, config.key);
    });
    setFieldDisabled(state, "year", false);
    setFieldDisabled(state, "make", !state.selections.year || !state.options.make.length);
    setFieldDisabled(state, "model", !state.selections.make || !state.options.model.length);
    if (submitButton) {
      submitButton.disabled = !isComplete;
      submitButton.setAttribute("aria-disabled", isComplete ? "false" : "true");
      submitButton.classList.toggle("is-ready", isComplete);
    }
  }
  function isSelectionComplete(state) {
    return !!(state.selections.year && state.selections.make && state.selections.model);
  }
  function dispatchSelectorChange(state, fieldKey, options) {
    var detail = {
      field: fieldKey,
      value: state.selections[fieldKey] || "",
      complete: isSelectionComplete(state),
      skipSubmit: !!(options && options.skipSubmit),
      selections: {
        year: state.selections.year || "",
        make: state.selections.make || "",
        model: state.selections.model || ""
      }
    };
    var event;

    if (typeof window.CustomEvent === "function") {
      state.root.dispatchEvent(new window.CustomEvent("auxito:home-vehicle-selector:change", {
        bubbles: true,
        detail: detail
      }));
      return;
    }

    event = document.createEvent("CustomEvent");
    event.initCustomEvent("auxito:home-vehicle-selector:change", true, false, detail);
    state.root.dispatchEvent(event);
  }
  async function loadYears(state) {
    var api = await waitForVehicleDataApi();
    var data = await api.getVehicleData();
    state.options.year = api.getAvailableYears(data);
    populateNativeSelect(state, "year", state.options.year);
    populateDesktopSelect(state, "year", state.options.year);
  }
  async function loadMakes(state, year) {
    var api = await waitForVehicleDataApi();
    var data = await api.getVehicleData();
    state.options.make = api.getAvailableMakes(data, year);
    populateNativeSelect(state, "make", state.options.make);
    populateDesktopSelect(state, "make", state.options.make);
  }
  async function loadModels(state, year, make) {
    var api = await waitForVehicleDataApi();
    var yearData = await api.getYearVehicleData(year);
    state.options.model = api.getAvailableModels(yearData, make);
    populateNativeSelect(state, "model", state.options.model);
    populateDesktopSelect(state, "model", state.options.model);
  }
  function syncVehicleStorageUi() {
    var vehicleUtils = getVehicleUtils();
    if (vehicleUtils && typeof vehicleUtils.syncVehicleStorageUi === "function") {
      vehicleUtils.syncVehicleStorageUi({
        showSelectedState: true
      });
    }
  }
  // 06 清单条目 [handle, 品牌, 显示车型, 年份[], 年份段, 车型库品牌, 车型库车型[]]（assets/auxito-bsg2-directory.json，与 06 页、品牌页选车同一份）。
  // 「品牌-车型」网址对外恢复了旧版内容（运营 9-28），带 view=bulb-size-guide-v2 显示新版并定位年份；年份开头的网址本身就是新版。
  function bsgUrl(src, year, make, model) {
    var flat = function(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]/g, ""); };
    if (!src) return Promise.resolve(null);
    return fetch(src, { credentials: "omit" }).then(function(r) { return r.json(); }).then(function(d) {
      var y = Number(year);
      if (!d || !Array.isArray(d.pages)) return null;
      var p = (d.pages || []).filter(function(e) {
        return flat(e[5]) === flat(make) && (e[6] || []).some(function(m) { return flat(m) === flat(model); }) && (e[3] || []).indexOf(y) >= 0;
      })[0];
      if (!p) return "";
      var q = new URLSearchParams({ year: year, model: p[2], save: "1" });
      if (!/^\d/.test(p[0])) q.set("view", "bulb-size-guide-v2");
      return "/pages/" + p[0] + "?" + q.toString();
    }).catch(function() { return null; }); /* 清单读不到 / 格式不对（null）与清单里没有这台车（""）分开：读不到时照旧进旧版车型页 */
  }
  // 06 清单里没有这台车：在选车卡里直接给结果和下一步（运营 2026-10-23「暂无已验证灯泡数据 + 联系适配支持 / 检查原车灯泡型号」），不再跳旧版车型页让人以为按钮无效
  function showNoBulbData(state, vehicle) {
    var form = state.root.querySelector("[data-home-vehicle-form]");
    var box = state.root.querySelector("[data-home-vehicle-nodata]");
    var footerLink = state.root.querySelector(".auxito-vehicle-card__footer a");
    var el = function(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
    var actions, support, guide;
    if (!form) return false;
    if (!box) {
      box = el("div", "home-vehicle-selector__nodata");
      box.setAttribute("data-home-vehicle-nodata", "");
      box.setAttribute("role", "status");
      form.parentNode.insertBefore(box, form.nextSibling);
    }
    box.textContent = "";
    box.appendChild(el("p", "home-vehicle-selector__nodata-title", "No verified bulb data for your " + buildVehicleDisplay(vehicle).replace(/\bHd\b/g, "HD") + " yet"));
    box.appendChild(el("p", "home-vehicle-selector__nodata-text", "We haven\u2019t verified the factory bulb sizes for this vehicle. Check the part number printed on your original bulb, or contact our fitment support and we\u2019ll confirm the right bulbs for you."));
    actions = el("div", "home-vehicle-selector__nodata-actions");
    support = el("a", "auxito-yellow-button", "Contact Fitment Support");
    support.href = footerLink && footerLink.getAttribute("href") || "/pages/get-in-touch";
    /* 与卡片底部的支持按钮同一入口（后台可设为打开在线客服） */
    support.addEventListener("click", function(event) {
      if (!footerLink || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; /* 新标签页打开照浏览器默认 */
      event.preventDefault();
      footerLink.click();
    });
    guide = el("a", "auxito-outline-button", "How to Check Your Bulb");
    guide.href = "#auxito-find-title";
    /* 页头吸顶：滚动时扣掉页头高度，标题不被挡住 */
    guide.addEventListener("click", function(event) {
      var target = document.getElementById("auxito-find-title");
      var header = document.getElementById("shopify-section-static-header");
      if (!target || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true }); /* 键盘 / 读屏用户接着从这一节往下读 */
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - (header ? header.getBoundingClientRect().height : 0) - 12, behavior: window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    });
    actions.appendChild(support);
    actions.appendChild(guide);
    box.appendChild(actions);
    box.hidden = false;
    try { window.AuxitoTrack && window.AuxitoTrack.result("bsg_no_data"); } catch (error) {}
    return true;
  }
  function submitSelection(state) {
    var year = state.selections.year;
    var make = state.selections.make;
    var model = state.selections.model;
    var storage = getVehicleStorage();
    var params;
    var resultsUrl;
    if (!year || !make || !model || state.isSubmitting) {
      return;
    }
    state.isSubmitting = true;
    try { window.AuxitoTrack && window.AuxitoTrack.vehicleSelected(state.root.getAttribute("data-home-vehicle-selector-target") === "bsg" ? "bsg_search" : "home_finder", year, make, model); } catch (error) {} /* 车型页埋点：全站选车也上报（assets/auxito-proto-shell-tracking.js） */
    params = new URLSearchParams({
      year: year,
      make: make,
      model: model
    });
    resultsUrl = state.root.getAttribute("data-home-vehicle-selector-results-url") || "/pages/vehicle11";
    if (storage && typeof storage.addVehicle === "function") {
      storage.addVehicle({
        id: Date.now() + Math.random(),
        year: year,
        make: make,
        model: model,
        display: buildVehicleDisplay({
          year: year,
          make: make,
          model: model
        })
      });
      syncVehicleStorageUi();
    }
    // 运营 2026-10-10：两种入口目的不同——
    // · Bulb Size 类（/pages/search「Find Your Bulb Size」，section 标 data-home-vehicle-selector-target="bsg"）：查灯泡型号，进这台车的 06 灯泡尺寸页
    //   并定位所选年份（与旧品牌 Bulb Size 页选车同一份 06 清单）；清单里没有这台车时在选车卡里提示暂无已验证灯泡数据（运营 2026-10-23），清单读不到时进旧版车型页
    // · 首页 Shop by Vehicle：找这台车能买什么，进 03 年份车型页（与页头 My Garage 同一规则）；这台车还没有年份页（未上线车型）时照旧进旧版车型页
    if (state.root.getAttribute("data-home-vehicle-selector-target") === "bsg") {
      var token = state.submitToken = (state.submitToken || 0) + 1;
      bsgUrl(state.root.getAttribute("data-bsg-directory"), year, make, model).then(function(url) {
        if (token !== state.submitToken) return; /* 查询返回前已换车：这次结果作废 */
        if (url === "" && showNoBulbData(state, { year: year, make: make, model: model })) {
          state.isSubmitting = false;
          return;
        }
        window.location.href = url || "/pages/vehicle?" + params.toString();
      });
      return;
    }
    var fallback = resultsUrl + "?" + params.toString();
    var yearPage = "/pages/vehicle-year/" + [year, make, model].join("-").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    fetch(yearPage, { method: "HEAD", credentials: "same-origin" }).then(function(response) {
      window.location.href = response.ok ? yearPage : fallback;
    }).catch(function() {
      window.location.href = fallback;
    });
  }
  async function handleFieldSelection(state, fieldKey, value, options) {
    var nativeSelect = state.nativeSelects[fieldKey];
    if (!nativeSelect) {
      return;
    }
    nativeSelect.value = value;
    value = nativeSelect.value || "";
    var noData = state.root.querySelector("[data-home-vehicle-nodata]");
    var isBsg = state.root.getAttribute("data-home-vehicle-selector-target") === "bsg";
    /* /pages/search 重选当前值：下一级列表已读到时什么都不改（不清空后面的选择，查询照常返回）；没读到时照旧重新读取 */
    if (isBsg && value && value === (state.selections[fieldKey] || "") && (fieldKey === "model" || ((state.options || {})[fieldKey === "year" ? "make" : "model"] || []).length)) {
      updateUi(state);
      return;
    }
    /* 换了车：收起上一台车的「暂无数据」结果，还没返回的查询作废 */
    if (isBsg) {
      if (noData) noData.hidden = true;
      state.submitToken = (state.submitToken || 0) + 1;
      state.isSubmitting = false;
    }
    if (fieldKey === "year") {
      state.selections.year = value;
      resetField(state, "make", true);
      resetField(state, "model", true);
      if (value) {
        await loadMakes(state, value);
      }
      updateUi(state);
      dispatchSelectorChange(state, fieldKey, options || {});
      return;
    }
    if (fieldKey === "make") {
      state.selections.make = value;
      resetField(state, "model", true);
      if (value) {
        await loadModels(state, state.selections.year, value);
      }
      updateUi(state);
      dispatchSelectorChange(state, fieldKey, options || {});
      return;
    }
    state.selections.model = value;
    updateUi(state);
    dispatchSelectorChange(state, fieldKey, options || {});
  }
  async function restoreSavedVehicle(state) {
    var storage = getVehicleStorage();
    var savedVehicle = null;
    if (!storage || typeof storage.load !== "function") {
      return;
    }
    try {
      savedVehicle = storage.load().current;
    } catch (error) {
      savedVehicle = null;
    }
    if (!savedVehicle) {
      return;
    }
    if (savedVehicle.year) {
      await handleFieldSelection(state, "year", String(savedVehicle.year), {
        skipSubmit: true
      });
    }
    if (savedVehicle.make) {
      await handleFieldSelection(state, "make", String(savedVehicle.make), {
        skipSubmit: true
      });
    }
    if (savedVehicle.model) {
      await handleFieldSelection(state, "model", String(savedVehicle.model), {
        skipSubmit: true
      });
    }
  }
  function bindFieldEvents(state, fieldKey) {
    var selectRoot = state.desktopSelects[fieldKey];
    var trigger = selectRoot ? selectRoot.querySelector(".home-vehicle-selector__trigger") : null;
    var optionsContainer = selectRoot ? selectRoot.querySelector(".home-vehicle-selector__options") : null;
    var nativeSelect = state.nativeSelects[fieldKey];
    if (!selectRoot || !trigger || !optionsContainer || !nativeSelect) {
      return;
    }
    trigger.addEventListener("click", function(event) {
      var willOpen;
      event.preventDefault();
      event.stopPropagation();
      if (selectRoot.classList.contains("is-disabled")) {
        return;
      }
      willOpen = !selectRoot.classList.contains("is-open");
      closeAllSelects(state);
      selectRoot.classList.toggle("is-open", willOpen);
      trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
    optionsContainer.addEventListener("click", async function(event) {
      var option = event.target.closest(".home-vehicle-selector__option");
      if (!option) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      closeAllSelects(state);
      try {
        await handleFieldSelection(state, fieldKey, option.dataset.value || "", {});
      } catch (error) {
        console.error("Failed to update vehicle selector field:", error);
      }
    });
    nativeSelect.addEventListener("change", function() {
      handleFieldSelection(state, fieldKey, nativeSelect.value || "", {}).catch(function(error) {
        console.error("Failed to sync native vehicle selector field:", error);
      });
    });
  }
  function bindSubmitEvents(state) {
    var submitButton = state.root.querySelector("[data-home-vehicle-submit]");
    if (!submitButton) {
      return;
    }
    submitButton.addEventListener("click", function(event) {
      event.preventDefault();
      submitSelection(state);
    });
  }
  // Can't find your vehicle? → 客服表单，带上已选的年份 / 品牌 / 车型（值来自车型目录选项，只放过简单字符）
  function bindHelpEvents(state) {
    var helpLink = state.root.querySelector("[data-home-vehicle-help]");
    if (!helpLink) {
      return;
    }
    var syncHelpHref = function() {
      var parts = ["year", "make", "model"].map(function(key) {
        return String(state.selections[key] || "").trim();
      }).filter(function(value) {
        return value && /^[0-9A-Za-z .\-()\/&']{1,40}$/.test(value);
      });
      var url = "/pages/get-in-touch?topic=fitment";
      if (parts.length) {
        url += "&vehicle=" + encodeURIComponent(parts.join(" "));
      }
      helpLink.setAttribute("href", url);
    };
    // 打开链接前的每种方式都先同步（左键、中键 / 右键新标签、键盘、触摸），避免沿用上次的车型（PR #56 审查）
    ["pointerdown", "mousedown", "touchstart", "focus", "contextmenu", "auxclick", "click"].forEach(function(type) {
      helpLink.addEventListener(type, syncHelpHref, { passive: true });
    });
    state.root.addEventListener("change", syncHelpHref);
    syncHelpHref();
  }
  function bindGlobalEvents(state) {
    document.addEventListener("click", function(event) {
      if (!event.target.closest("[data-home-vehicle-selector]")) {
        closeAllSelects(state);
      }
    });
    document.addEventListener("keydown", function(event) {
      if (event.key === "Escape") {
        closeAllSelects(state);
      }
    });
  }
  function createState(root) {
    var state = {
      root: root,
      desktopSelects: {},
      nativeSelects: {},
      selections: {
        year: "",
        make: "",
        model: ""
      },
      options: {
        year: [],
        make: [],
        model: []
      },
      isSubmitting: false
    };
    FIELD_CONFIGS.forEach(function(config) {
      state.desktopSelects[config.key] = root.querySelector('[data-home-vehicle-select="' + config.key + '"]');
      state.nativeSelects[config.key] = root.querySelector('[data-home-vehicle-native="' + config.key + '"]');
    });
    return state;
  }
  function canInitialize(state) {
    return !!(state.nativeSelects.year && state.nativeSelects.make && state.nativeSelects.model);
  }
  async function initRoot(root) {
    var state;
    if (!root || root.dataset.homeVehicleSelectorReady === "true") {
      return;
    }
    state = createState(root);
    if (!canInitialize(state)) {
      return;
    }
    root.dataset.homeVehicleSelectorReady = "true";
    FIELD_CONFIGS.forEach(function(config) {
      bindFieldEvents(state, config.key);
    });
    bindSubmitEvents(state);
    bindHelpEvents(state);
    bindGlobalEvents(state);
    try {
      await loadYears(state);
      await restoreSavedVehicle(state);
    } catch (error) {
      console.error("Failed to initialize home vehicle selector:", error);
    }
    updateUi(state);
  }
  function initAll() {
    initHeroCarousels();
    Array.prototype.forEach.call(document.querySelectorAll("[data-home-vehicle-selector]"), function(root) {
      initRoot(root);
    });
  }
  function initHeroCarousels() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-home-hero-carousel]"), function(carousel) {
      var slides = Array.prototype.slice.call(carousel.querySelectorAll("[data-home-hero-slide]"));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll("[data-home-hero-dot]"));
      var previousButton = carousel.querySelector("[data-home-hero-prev]");
      var nextButton = carousel.querySelector("[data-home-hero-next]");
      var autoplay = carousel.getAttribute("data-home-hero-autoplay") !== "false";
      var interval = parseInt(carousel.getAttribute("data-home-hero-interval"), 10) || 5e3;
      var activeIndex = 0;
      var timer = null;
      function showSlide(index) {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach(function(slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });
        dots.forEach(function(dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle("is-active", isActive);
          dot.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      }
      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }
      function start() {
        if (!autoplay || slides.length < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        stop();
        timer = window.setInterval(function() {
          showSlide(activeIndex + 1);
        }, interval);
      }
      dots.forEach(function(dot, index) {
        dot.addEventListener("click", function() {
          showSlide(index);
          start();
        });
      });
      if (previousButton) {
        previousButton.addEventListener("click", function() {
          showSlide(activeIndex - 1);
          start();
        });
      }
      if (nextButton) {
        nextButton.addEventListener("click", function() {
          showSlide(activeIndex + 1);
          start();
        });
      }
      carousel.addEventListener("mouseenter", stop);
      carousel.addEventListener("mouseleave", start);
      showSlide(0);
      start();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})(window, document);
